<template xmlns:v-on="http://www.w3.org/1999/xhtml">
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="$store.getters.role == 1 || $store.getters.role == 2">
            <div class="container-fluid xyz">
                <div class="page-header-top-container">
                    <!-- <div class="page-name">List Tickets</div> -->
                    <div class="page-name">Store wait times</div>
                    <button type="button" class="btn btn-secondary" v-on:click="exportTicket($event)">Export</button>
                </div>

                <!--page content-->
                <div class="admin-page-content">
                    <!-- List Content Here -->
                    <!-- List Content Here -->
                    <div class="card">
                        <h5 class="card-header" style="background:#f5f5f5;">
                            <div class="">
                                <div class="selectdate">


                                    <!--<vue-ctk-date-time-picker range >-->

                                    <!--</vue-ctk-date-time-picker>-->
                                    <div class="selectbox1">
                                        <VueCtkDateTimePicker range v-model="date_picker_dates"
                                                              :only-time="false"
                                                              :format="date_picker_options.inputFormat"
                                                              :formatted="date_picker_options.formatted"
                                                              :noClearButton="true"
                                                              :maxDate="date_picker_options.maxDate"
                                                              :custom-shortcuts="date_picker_options.customShortcuts"
                                                              @input="changeDatePickerDate()"
                                        ></VueCtkDateTimePicker>
                                        <span class="text-danger">{{datePickerError}}</span>
                                    </div>
                                    <!--<div class="selectbox1">-->
                                        <!--<datetime type="date"-->
                                                <!--v-model="ticketData.from_date"-->
                                                <!--:max-datetime="ticketData.to_date"-->
                                                <!--id="from-date"-->
                                                <!--placeholder="From Date"-->
                                                <!--v-validate="'required'"-->
                                                <!--:value-zone="time_zone"-->
                                                <!--name="From date" auto>-->
        <!---->
                                        <!--</datetime>-->
                                        <!--<span v-if="errors.has('From date')" class="text-danger" >{{ errors.first('From date') }}</span>-->
                                        <!--:value-zone="'America/Los_Angeles'"
                                                :zone="'America/Los_Angeles'" -->
                                        <!--<span>{{ errors.first('from_date') }}</span>-->
                                        <!--<label class="text-danger" id="from-date-error" v-if="ticketDataError.from_date">{{ ticketDataError.from_date }}</label>-->

                                    <!--</div>-->

                                    <!--<div class="selectbox1">-->
                                        <!--<datetime type="date"-->
                                                <!--v-model="ticketData.to_date"-->
                                                <!--:min-datetime="ticketData.from_date"-->
                                                <!--id="to-date"-->
                                                <!--v-validate="'required'"-->
                                                <!--name="To date"-->
                                                <!--:value-zone="time_zone"-->
                                                <!--placeholder="To Date" auto></datetime>-->
                                            <!--<span v-if="errors.has('To date')" class="text-danger" >{{ errors.first('To date') }}</span>-->
                                        <!--&lt;!&ndash;<label class="text-danger" v-if="ticketDataError.to_date">{{ ticketDataError.to_date }}</label>&ndash;&gt;-->
                                    <!--</div>-->

                                    <div class="selectbtn">
                                        <button type="button" class="btn btn-warning applybtn" v-on:click="checkDate()">Apply Filter</button>
                                        <button type="button" class="btn btn-primary clearbtn" v-on:click="clearFilter()">Clear Filter</button>
                                    </div>
                                
                                </div>

                               
                            
                            </div>
                        </h5>
                    </div>
                    <div class="card-body">
                        <vue-good-table
                                :columns="columns"
                                :rows="rows"
                                :line-numbers="true"
                                :searchOptions="{enabled: true,placeholder:'Search by Location'}"
                                :pagination-options="{
                                                enabled: false,
                                                mode: 'pages'
                                            }"
                        ></vue-good-table>
                    </div>
                </div>


            </div>
        </template>
        <template v-else>
            <no-permission></no-permission>
        </template>
        <app-footer></app-footer>
    </div>
    <!-- /#page-content-wrapper -->
</template>


<script>
    // import vSelect from 'vue-select';
    import Vue from 'vue'
    import FrontFooter from '@/components/FrontFooter';
    import NoAccessPermission from '@/components/NoAccessPermission'
    import {HTTP} from '../http-common';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    import Datepicker from 'vuejs-datepicker';
    import {Datetime} from 'vue-datetime'
    import 'vue-datetime/dist/vue-datetime.css'
    import {commonMixins} from '../mixins/commonMixins';
    import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
    import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

    export default {
        name: "FilteredListTicket",
        mixins: [commonMixins],
        components: {
            'app-footer':FrontFooter,
            'no-permission': NoAccessPermission,
            Datepicker,
            datetime: Datetime,
            'vue-ctk-date-time-picker' : VueCtkDateTimePicker,
        },
        data() {
            return {

                columns: [
                    {
                        label: 'Location Name',
                        field: 'name',
                        filterable: false,
                        type: 'string'
                    },
                    {
                        label: 'Average Waiting Time',
                        field: 'total_wait',
                        filterable: false,
                        type: 'string',
                    },
                    {
                        label: 'Numbers Considered',
                        field: 'size',
                        filterable: false,
                        type: 'number',
                    },
                    {
                        label: 'Customer Not In Queue',
                        field: 'customer_not_in_queue',
                        filterable: false,
                        type: 'number',

                    },

                ],
                date_picker_options: {
                    maxDate : '',
                    inputFormat: 'YYYY-MM-DD',
                    formatted: 'MMM DD, YYYY',//'YYYY-MM-DD',
                    customShortcuts : [
                        /* { label: 'Yesterday', value: '-day', isSelected: false },
                        { label: 'This Week', value: 'week', isSelected: false },
                        { label: 'Last Week', value: '-week', isSelected: false },
                        { label: 'This Month', value: 'month', isSelected: false },
                        { label: 'Last Month', value: '-month', isSelected: false }, */
                        { key: 'yesterday', label: 'Yesterday', value: '-day', isSelected: false },
                        { key: 'thisWeek', label: 'This Week', value: 'isoWeek', isSelected: false },
                        { key: 'lastWeek', label: 'Last Week', value: '-isoWeek', isSelected: false },
                        { key: 'thisMonth', label: 'This Month', value: 'month', isSelected: false },
                        { key: 'lastMonth', label: 'Last Month', value: '-month', isSelected: false },
                    ]
                },
                date_picker_dates: {
                    "start": "2019-03-06",
                    "end": "2019-03-27"
                },
                rows: [],
                ticketData:{
                    from_date:'',
                    to_date:'',
                },
                ticketDataError:{
                    from_date:'',
                    to_date:'',
                },
                local_time_zone: '',
                time_zone: '',

                // frontend errors
                datePickerError : '',
            }
        },
        mounted:function(){
            let self = this;
            self.local_time_zone = self.user_time_zone;
            console.log(self.local_time_zone);
            var date = new Date();
            self.time_zone = self.$moment.tz.guess();
            var start_date = self.formatDate(self.$moment(date).tz(self.time_zone).subtract(7, 'days').toISOString()); // setting start date to previous 7 days
            var end_date = self.formatDate(self.$moment(date).tz(self.time_zone).toISOString());
            self.ticketData.from_date = start_date;
            self.ticketData.to_date = end_date;
            let today = new Date();
            let dd = String(today.getDate()).padStart(2, '0');
            let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
            let yyyy = today.getFullYear();
            today = yyyy + '-' + mm + '-' + dd;
            self.date_picker_dates = {
                start : today,
                end : today,
            };
            self.ticketData = {
                from_date : self.date_picker_dates.start.split(' ')[0],
                to_date : self.date_picker_dates.end.split(' ')[0],
            };
            self.date_picker_options.maxDate = today;
            if (self.date_picker_dates.end === null) {
                self.date_picker_dates.end = self.date_picker_dates.start;
            }
            self.ticketData = {
                from_date : self.date_picker_dates.start.split(' ')[0],
                to_date : self.date_picker_dates.end.split(' ')[0],
            };
            self.loadTickets();
        },
        methods: {
            clearFilter(){
                let self = this;
                self.ticketData.to_date='';
                self.ticketData.from_date='';
                self.date_picker_dates.start = '';
                self.date_picker_dates.end = '';
                this.$validator.reset();
                self.loadTickets();
            },
            changeDatePickerDate : function () {
                self.datePickerError = '';
            },
            checkForm() {
                let checked = true;
                let self = this;
                if (self.date_picker_dates.start == '' && self.date_picker_dates.end == '') {
                    self.datePickerError = "Please Select Date";
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },
            checkDate()
            {
                let self = this;
                if (self.date_picker_dates.end === null) {
                    self.date_picker_dates.end = self.date_picker_dates.start;
                }
                self.ticketData = {
                    from_date : self.date_picker_dates.start.split(' ')[0],
                    to_date : self.date_picker_dates.end.split(' ')[0],
                };
                if (self.checkForm()) {
                    self.loadTickets();
                } else {
                    return;
                }
            },
            loadTickets()
            {
                let self = this;
                console.log(JSON.stringify(self.ticketData));
                var date_object = {
                    from_date: self.formatDate(self.ticketData.from_date),
                    to_date: self.formatDate(self.ticketData.to_date)
                };

                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: { 
                        'date': date_object,
                        //'time_considered': self.time_considered,
                    }
                };

                HTTP.get('avg/ticket/wait', config)
                    .then(function (response) {
                        // console.log(response);
                        if (response.data.code == '200') {

                            self.rows = response.data.content.avg_per_store;
                            self.ticketDataError.to_date='';
                            self.ticketDataError.from_date='';
                        }
                        // self.locationOptions= response.data.content;
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = err.response.data.message;
                        }
                    })
            },
            exportTicket : function (e) {
                let self = this;
                if (self.date_picker_dates.end === null) {
                    self.date_picker_dates.end = self.date_picker_dates.start;
                }
                self.ticketData = {
                    from_date : self.date_picker_dates.start.split(' ')[0],
                    to_date : self.date_picker_dates.end.split(' ')[0],
                };
                var date_object = {
                    from_date: self.formatDate(self.ticketData.from_date),
                    to_date: self.formatDate(self.ticketData.to_date)
                };

                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: { 
                        'date': date_object,
                        //'time_considered': self.time_considered,
                    }
                };

                HTTP.get('avgWaitTicket/export', config)
                    .then(function (response) {
                        if (response.data.code == 200) {
                            location.href = response.data.content.web;
                            //self.rows = response.data.content.row;
                            //self.totalRecords = response.data.content.totalRecords;
                        } else if(response.data.code == 404) {
                            console.log(response.data.message);
                        }
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = err.response.data.message;
                        }
                    })
            },
        },
        computed: {
            user_time_zone: {
                get() {
                    return this.$store.getters.user_time_zone;
                },
                set(value) {
                    this.$store.commit('changeUserTimeZone', value)
                }
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/FilteredListTicket.vue